import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  Input,
  Directive,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import {
  ModalController,
  App,
  NavController,
  ToastController,
  ViewController,
} from 'ionic-angular';
import { UserProvider } from '../../../providers/user/user';
import { ToolsProvider } from '../../../providers/tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';
import { AppVersion } from '@ionic-native/app-version';
import { EnvVariables } from '../../../environments/environment';
import { ConfigProvider } from '../../../providers/config/config';
import { Capacitor } from '@capacitor/core';
import { LiveChatProvider } from '../../../providers/live-chat/live-chat';

@Component({
  selector: 'lc-reply-to-reply',
  templateUrl: 'reply-to-reply.html',
})
export class LCReplyToReplyComponent {
  log = debug('app:LCReplyToReplyComponent');

  @Input() replyId = null;
  @Input() reply = {};
  constructor(
    public modalCtrl: ModalController,
    public user: UserProvider,
    public appCtrl: App,
    public tools: ToolsProvider,
    public appVersion: AppVersion,
    public navCtrl: NavController,
    private env: EnvVariables,
    public configs: ConfigProvider,
    public cdr: ChangeDetectorRef,
    public liveChat: LiveChatProvider,
    public toastCtrl: ToastController,
    public viewCtrl: ViewController
  ) {}

  ngOnInit() {
    this.setReply();
  }

  setReply() {
    if (this.replyId && !_.size(this.reply)) {
      this.liveChat.findReply(this.replyId).then(res => {
        this.log('res', res);
        this.reply = res?.data;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/reply-to-reply/reply-to-reply.ts